export default "__VITE_ASSET__b2b35c38__"